/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, onUnmounted } from "vue";
import { v4 as uuidv4 } from "uuid";
import $ from './ExtendedJquery';

function commonBlock(message : string) {
	if (!(
		$(window).data("blockUI.isBlocked") === 1 || 
		((window as any).$ !== undefined && (window as any).$(window).data("blockUI.isBlocked") === 1)
	))
	{
		$.blockUI({
			message,
			fadeIn: 0,
			baseZ: 100000,
			css: {
				border: 'none',
				padding: '15px',
				backgroundColor: '#000',
				'-webkit-border-radius': '10px',
				'-moz-border-radius': '10px',
				'border-radius': '10px',
				opacity: 0.7,
				'font-weight': 'bold',
				'font-size': '13px',
				color: '#fff',
			},
		});
	}
}

function commonUnblock() {
	$.unblockUI();

	if ((window as any).$ !== undefined && (window as any).$(window).data("blockUI.isBlocked") === 1)
	{
		(window as any).$.unblockUI();
	}
}

let visible = false;

const allSymbol = Symbol("globalBlock");

export interface Blocking {
    [key: string]: boolean
    [allSymbol]?: boolean
}

const blocking : Blocking = {};

export function block(message : string, uuid?: string): void {
	blocking[uuid || allSymbol] = true;
	if (!visible)
	{
		visible = true;
		commonBlock(message);
	}
}

export function unblock(uuid?: string): void {
	if (blocking[uuid || allSymbol])
	{
		delete blocking[uuid || allSymbol];
		if (Object.keys(blocking).length === 0)
		{
			visible = false;
			commonUnblock();
		}
	}
}

export function getUUID(): string {
	const uuid = uuidv4();
	onUnmounted(() => {
		unblock(uuid);
	});
	return uuid;
}

const component = defineComponent({
	name: "BlockUI",
	data() {
		return {
			uuid: uuidv4().replaceAll(/-/g, ''),
		};
	},
	methods: {
		block(message : string): void {
			blocking[this.uuid] = true;
			if (!visible)
			{
				visible = true;
				commonBlock(message);
			}
		},
		unblock(): void {
			if (blocking[this.uuid])
			{
				delete blocking[this.uuid];
				if (Object.keys(blocking).length === 0)
				{
					visible = false;
					commonUnblock();
				}
			}
		},
	},
	beforeUnmount() {
		this.unblock();
	},
});

export default component;

export const VueBlockUI = {
	block,
	unblock,
	getUUID,
	install: (app: any): void => {
		app.mixin(component);
	},
};
